import {handleActions} from 'redux-actions'
import {setEditable, emailSent, throwInlineError} from './actions'

export const initialState = {
  editable: null,
  inlineError: null,
  sentEmails: []
}

export default handleActions(
  {
    [setEditable](state, {payload}) {
      return {
        ...state,
        editable: payload,
        inlineError: null
      }
    },

    [throwInlineError](state, {payload}) {
      return {
        ...state,
        inlineError: payload
      }
    },

    [emailSent](state, {payload}) {
      return {
        ...state,
        sentEmails: state.sentEmails.concat(payload)
      }
    }
  },
  initialState
)
